import { cn } from '@/shared/utils/cn';

export const Loader = ({
  size = 18,
  color = 'white',
}: {
  size?: number;
  color?: 'white' | 'primary';
}) => {
  return (
    <div
      className={cn(
        'mb-0.5 ml-px animate-spin rounded-full border-2 border-white',
        color === 'primary' && 'border-primary',
        'border-t-transparent',
      )}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    />
  );
};
